import { type FC, useCallback, useContext } from "react";

import { lensGroupSuccessfullyDeleted } from "../../common/model";
import { Notification } from "@snapchat/snap-design-system";
import { type ModalProps } from "../../core/hooks";
import { GroupStatus } from "../../../gql-generated/types";
import { DeleteLensGroupModal } from "../components/DeleteLensGroupModal";
import { useSaveGroup } from "../hooks";
import { type BaseGroupInfo } from "../model";

export interface DeleteGroupContainerProps extends ModalProps {
    group: BaseGroupInfo;
    onLensGroupSuccessfullyDeleted?: () => void;
}

export const DeleteLensGroupModalContainer: FC<DeleteGroupContainerProps> = ({
    group,
    onLensGroupSuccessfullyDeleted,
    ...modalProps
}) => {
    const { saveGroup, loading } = useSaveGroup();
    const { success } = useContext(Notification.Context);

    const deleteLensGroup = useCallback(async () => {
        if (group.id != null) {
            await saveGroup({ id: group.id, name: group.name, status: GroupStatus.Archived }).then(() => {
                modalProps.onCancel();
                if (onLensGroupSuccessfullyDeleted) {
                    onLensGroupSuccessfullyDeleted();
                }
                success(lensGroupSuccessfullyDeleted);
            });
        }
    }, [group, modalProps, onLensGroupSuccessfullyDeleted, saveGroup, success]);

    return <DeleteLensGroupModal groupIsDeleting={loading} onDeleteLensGroup={deleteLensGroup} {...modalProps} />;
};
